import React from "react";
import Hero from "../Components/Hero/Hero";
import NewLetter from "../Components/newLetter/NewLetter";
const Contact = () => {
  return (
    <div className="home_page">
      <Hero />
      <NewLetter />
    </div>
  );
};

export default Contact;
